<template>
	<div>
		<PortalAuthRequestCode v-if="!email" @email-submitted="handleEmailSubmitted" :requestCodeText="requestCodeText" />
		<PortalAuthEnterCode v-else @code-submitted="handleCodeSubmitted" :email="email" :isCodeWrong="codeExchangeFailed" />
	</div>
</template>

<script>
import PortalAuthEnterCode from './PortalAuthEnterCode.vue';
import PortalAuthRequestCode from './PortalAuthRequestCode.vue';
import { requestPortalAuthCode, exchangePortalAuthCode } from '@/api';

export default {
	name: 'PortalAuth',
	props: { workflowId: { type: String, required: true }, requestCodeText: { type: String, required: true } },
	components: {
		PortalAuthRequestCode,
		PortalAuthEnterCode,
	},
	data() {
		return { email: '', codeExchangeFailed: false };
	},
	computed: {},
	methods: {
		async handleEmailSubmitted(email) {
			await requestPortalAuthCode({ email, workflow_hash: this.workflowId });
			this.email = email;
		},
		async handleCodeSubmitted(code) {
			this.codeExchangeFailed = false;
			try {
				await exchangePortalAuthCode({ email: this.email, workflow_hash: this.workflowId, code });
				this.$emit('authenticated');
			} catch (err) {
				this.codeExchangeFailed = true;
				this.$toast.error(err.response?.data?.error?.msg);
				throw err;
			}
		},
	},
};
</script>

<style scoped lang="scss">
.user-registration-layout {
	background: none;
}

@media (max-width: $device-sm) {
	::v-deep .user-registration-layout {
		.inner-content-container > .flex-column {
			width: 90%;
		}
		.slot-card {
			box-shadow: none !important;
			max-width: none;
		}
	}
}
</style>
